import { render, staticRenderFns } from "./CardStat.vue?vue&type=template&id=36905c30&scoped=true"
import script from "./CardStat.vue?vue&type=script&lang=js"
export * from "./CardStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36905c30",
  null
  
)

export default component.exports